<template>
  <v-card>
    <v-card-title>
      <v-flex xs12 v-if="messages">
        <message :messages="messages"></message>
      </v-flex>
      <v-flex xs2>
        <div class="title">Items</div>
      </v-flex>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs4>
        <v-layout row>
          <v-spacer></v-spacer>
          <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
            <v-btn color="secondary" class="white--text" slot="activator">
              <span>Columns</span>
              <v-icon right dark>mdi-table-column-plus-after</v-icon>
            </v-btn>
            <v-card>
              <v-card-text>
                <template v-if="columns.length > 0">
                  <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
                </template>
                <template v-else>
                  No column found
                </template>
              </v-card-text>
            </v-card>
          </v-menu>
        </v-layout>
      </v-flex>
    </v-card-title>
    <v-data-table v-bind:headers="listHeaders" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="itemNo" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
      <td v-for="column in selectedColumns" :key="column">
        {{props.item[column]}}
      </td>
      <td class="text-xs-right">
        <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
      </td>
      </template>
    </v-data-table>
    <v-btn color="primary" dark class="mb-2" @click="doNew">New Item<v-icon>mdi-plus</v-icon></v-btn>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Item?
      <div class="title">{{deleteItem}}</div>
    </confirm>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { listMixin } from '@/components/parameters/reusable/listMixins'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number.js'
export default {
  data() {
    return {
      columns: [
        { text: 'Item No', value: 'itemNo' },
        { text: 'Default Benefit', value: 'benefitDesc' },
        { text: 'Default Unit Of Measure', value: 'uomDesc' },
        { text: 'Unit Of Measure UN', value: 'uomUn' },
        { text: 'Unit Of Measure Amount', value: 'uomAmt' },
        { text: 'Minimum Sum Insured', value: 'minSi' },
        { text: 'Minimum Sum Insured', value: 'maxSi' },
        { text: 'Protect Sum Insured', value: 'protSi' },
        { text: 'Increase Sum Insured', value: 'incSi' }
      ],
      pagination: {
        sortBy: 'itemNo'
      },
      selectedColumns: ['itemNo', 'uomDesc', 'uomAmt'],
      deleteItem: '',
      promptRemove: false,
      menu: []
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    pkgRiskMenu() {
      return this.$store.state.parameters.scheme.pkgRiskMenu
    }
  },
  watch: {
    'fetchItem': function(value) {
      if (value !== false) {
        if (this.ids.riskNo !== 'new') {
          this.fetchData(this.ids.riskNo)
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'pkgRiskMenuInit'
    ]),
    async fetchData(riskNo) {
      const expand = {
        scheme: this.ids.scheme,
        planNo: this.ids.planNo,
        riskNo: parseInt(this.ids.riskNo)
      }
      if (this.pkgRiskMenu.init !== 1) {
        await this.pkgRiskMenuInit(expand)
      }
      const apiURI = this.pkgRiskMenu.menu.pkgRiskItems
      if (apiURI) {
        const expand = {
          scheme: this.ids.scheme,
          planNo: this.ids.planNo,
          riskNo: riskNo
        }
        try {
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((pkgRiskItem) => {
              const convertPkgRiskItem = {
                scheme: pkgRiskItem.scheme,
                planNo: pkgRiskItem.planNo,
                riskNo: pkgRiskItem.riskNo,
                itemNo: pkgRiskItem.itemNo,
                benefit: pkgRiskItem.benefit,
                benefitDesc: pkgRiskItem.benefit + ' - ' + pkgRiskItem.benefitDesc,
                uom: pkgRiskItem.uom,
                uomDesc: pkgRiskItem.uom + ' - ' + pkgRiskItem.uomDesc,
                uomAmt: formatDisplayNumber(pkgRiskItem.uomAmt),
                uomUn: pkgRiskItem.uomUn,
                minSi: formatDisplayNumber(pkgRiskItem.minSi),
                maxSi: formatDisplayNumber(pkgRiskItem.maxSi),
                protSi: pkgRiskItem.protSi,
                incSi: formatDisplayNumber(pkgRiskItem.incSi)
              }
              this.items.push(convertPkgRiskItem)
            })
          } else {
            this.items = []
          }
          this.loading = false
        } catch (error) {
          this.loading = false
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API URL - Package Item List')
      }
    },
    doReview(data) {
      this.$emit('doReview', data.item)
    },
    doNew() {
      this.$emit('doNew')
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedItem = data
        this.deleteItem = data.riskNo
      }
    },
    async doRemove() {
      const apiURI = this.pkgRiskMenu.menu.pkgRiskItemDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          scheme: this.selectedItem.scheme,
          planNo: this.ids.planNo,
          riskNo: this.selectedItem.riskNo,
          itemNo: this.selectedItem.itemNo,
          benefit: this.selectedItem.benefit,
          benefitDesc: this.selectedItem.benefitDesc,
          uom: this.selectedItem.uom,
          uomDesc: this.selectedItem.uomDesc,
          uomAmt: removeFormatNumber(this.selectedItem.uomAmt),
          uomUn: this.selectedItem.uomUn,
          minSi: removeFormatNumber(this.selectedItem.minSi),
          maxSi: removeFormatNumber(this.selectedItem.maxSi),
          protSi: this.selectedItem.protSi,
          incSi: removeFormatNumber(this.selectedItem.incSi)
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.fetchData(this.ids.riskNo)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Risk Item')
      }
    }
  },
  props: {
    fetchItem: {
      type: Boolean,
      default: false
    },
    ids: {
      type: Object,
      default() {
        return {
          scheme: null,
          planNo: null,
          riskNo: null
        }
      }
    }
  },
  mixins: [
    MessageMixin,
    listMixin
  ]
}
</script>

<style>
</style>
